import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { useOutlet } from 'react-router-dom';
import { AppUI } from '@seedlang/state';
import styled from '@emotion/styled';
import SettingsMenuRow from 'components/user/settings_menu_row';
import MobileSettingsHeader from 'components/layout/mobile/settings_header';
import SettingsMenu, { MenuContainer } from 'components/user/settings_menu';
import HelpCenter from 'pages/main/help_center';
import { PlainPageHeadingContext } from 'components/plain_page_heading';
import { NamedRouteContext } from 'utils/named_route_context';

const MENU_ITEMS = [
  { route: 'help_center', label: 'Help Center' },
  { route: 'latest_decks', label: 'Deck History' },
  { route: 'comment_history', label: 'Comment History' },
  { route: 'blog', label: 'Blog' },
  { route: 'partners', label: 'Partners' },
  { route: 'privacy', label: 'Privacy' },
  { route: 'terms', label: 'Terms' },
  { route: 'contact', label: 'Contact Us' },
];

const Wrapper = styled.div`
  display: flex;
  flex-direction: ${props => props.isMobile ? 'column' : 'row'};
  align-items: flex-start;
  gap: 15px;
  width: 100%;
`;

const Content = styled.div`
  flex: 1;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  padding: ${props => props.isMobile ? '10px' : '30px'};
  border-radius: ${props => props.isMobile ? 0 : '10px'};
  background: white;
`;

const MobileMenu = styled.div`
  width: 100%;
  padding: 20px 15px;
  box-sizing: border-box;
`;

const More = observer(() => {
  const outlet = useOutlet();
  const namedRoutes = useContext(NamedRouteContext);
  const isMobile = AppUI.layout.isMobile;
  const showMenu = !isMobile || !outlet;
  const routeName = AppUI.routeStore.routeName;
  const contentRoutes = { ...namedRoutes };
  [...MENU_ITEMS.map(item => item.route), 'faq_categories.show', 'faq_items.show'].forEach(route => {
    contentRoutes[route] = namedRoutes[`more.${route}`];
  });

  const menu = (
    <MenuContainer
      width={isMobile ? '100%' : '250px'}
      borderRadius={isMobile ? '14px' : '10px'}
      isMobile={isMobile}
    >
      {MENU_ITEMS.map(item => (
        <SettingsMenuRow
          key={item.route}
          to={`more.${item.route}`}
          selected={routeName === `more.${item.route}` || (item.route === 'help_center' && (routeName === 'more' || routeName?.startsWith('more.faq_')))}
        >
          {item.label}
        </SettingsMenuRow>
      ))}
    </MenuContainer>
  );

  return (
    <Wrapper isMobile={isMobile}>
      {isMobile && (
        <MobileSettingsHeader
          title={outlet ? 'Back to More' : 'More'}
          onBack={() => AppUI.routeStore.routeToNamed(outlet ? 'more' : 'profile')}
        />
      )}
      {(!isMobile || outlet) && (
        <Content isMobile={isMobile}>
          <NamedRouteContext.Provider value={contentRoutes}>
            <PlainPageHeadingContext.Provider value={true}>
              {outlet || <HelpCenter />}
            </PlainPageHeadingContext.Provider>
          </NamedRouteContext.Provider>
        </Content>
      )}
      {showMenu && (isMobile ? (
        <MobileMenu>
          <SettingsMenu embeddedMobile />
          {menu}
        </MobileMenu>
      ) : menu)}
    </Wrapper>
  );
});

export default More;
